export const actions = {
    LOGOUT_DO: 'LOGOUT_DO',
    LOGIN_FROM_CODE: 'LOGIN_FROM_CODE',
    USER_INFO_FETCHED: 'USER_INFO_FETCHED',
    ASYNC_FETCH_APP_DATA: 'ASYNC_FETCH_APP_DATA',
    ASYNC_FETCH_ADMIN_DATA: 'ASYNC_FETCH_ADMIN_DATA',
    APP_LOGOUT: 'APP_LOGOUT',
    ASYNC_FETCH_CLASSES: 'ASYNC_FETCH_CLASSES',
    CLASSES_FETCHED: 'CLASSES_FETCHED',
    ASYNC_SAVE_CHANGES: 'ASYNC_SAVE_CHANGES',
    CHANGES_SAVED: 'CHANGES_SAVED',
    ASYNC_FETCH_CLASS: 'ASYNC_FETCH_CLASS',
    CLASS_FETCHED: 'CLASS_FETCHED',
    ASYNC_CREATE_CLASS: 'ASYNC_CREATE_CLASS',
    CLASS_CREATED: 'CLASS_CREATED',
    ASYNC_DELETE_CLASS: 'ASYNC_DELETE_CLASS',
    CLASS_DELETED: 'CLASS_DELETED',
    ASYNC_FETCH_COURSES: 'ASYNC_FETCH_COURSES',
    ASYNC_FETCH_TYPE_TESTS: 'ASYNC_FETCH_TYPE_TESTS',
    FETCH_TYPE_TESTS: 'FETCH_TYPE_TESTS',
    ASYNC_FETCH_TESTS_BY_TYPE: 'ASYNC_FETCH_TESTS_BY_TYPE',
    FETCH_TESTS_BY_TYPE: 'FETCH_TESTS_BY_TYPE',
    ASYNC_FETCH_TESTS_BY_COURSE: 'ASYNC_FETCH_TESTS_BY_COURSE',
    FETCH_TESTS_BY_COURSE: 'FETCH_TESTS_BY_COURSE',
    COURSES_FETCHED: 'COURSES_FETCHED',
    ASYNC_FETCH_COURSE: 'ASYNC_FETCH_COURSE',
    COURSE_FETCHED: 'COURSE_FETCHED',
    UPDATE_CLASS: 'UPDATE_CLASS',
    UPDATE_COURSE: 'UPDATE_COURSE',
    ASYNC_CREATE_COURSE: 'ASYNC_CREATE_COURSE',
    COURSE_CREATED: 'COURSE_CREATED',
    ASYNC_DELETE_COURSE: 'ASYNC_DELETE_COURSE',
    COURSE_DELETED: 'COURSE_DELETED',
    TCCS_FETCH_LOADING: 'TCCS_FETCH_LOADING',
    ASYNC_FETCH_SOME_TCCS: 'ASYNC_FETCH_SOME_TCCS',
    SOME_TCCS_FETCHED: 'SOME_TCCS_FETCHED',
    ASYNC_FETCH_ALL_TCCS: 'ASYNC_FETCH_ALL_TCCS',
    ALL_TCCS_FETCHED: 'ALL_TCCS_FETCHED',
    ASYNC_FETCH_SOME_USERS: 'ASYNC_FETCH_SOME_USERS',
    SOME_USERS_FETCHED: 'SOME_USERS_FETCHED',
    USERS_FETCH_LOADING: 'USERS_FETCH_LOADING',
    UPLOAD_FILE: 'UPLOAD_FILE',
    REQUEST_ERROR: 'REQUEST_ERROR',
    DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION',
    ASYNC_DOWNLOAD_TCC: 'ASYNC_DOWNLOAD_TCC',
    ASYNC_UPDATE_TCC: 'ASYNC_UPDATE_TCC',
    TCC_UPDATED: 'TCC_UPDATED',
    ASYNC_FETCH_TRAINERS: 'ASYNC_FETCH_TRAINERS',
    TRAINERS_FETCHED: 'TRAINERS_FETCHED',
    ASYNC_CREATE_TRAINER: 'ASYNC_CREATE_TRAINER',
    TRAINER_CREATED: 'TRAINER_CREATE',
    ASYNC_DELETE_TRAINER: 'ASYNC_DELETE_TRAINER',
    TRAINER_DELETED: 'TRAINER_DELETED',
    CENTERS_FETCHED: 'CENTERS_FETCHED',
    ASYNC_ENROLL_USER: 'ASYNC_ENROLL_USER',
    ASYNC_ENROLL_USER_FROM_REGISTER_NEW_USER:
        'ASYNC_ENROLL_USER_FROM_REGISTER_NEW_USER',
    ASYNC_UNENROLL_USER: 'ASYNC_UNENROLL_USER',
    USER_ENROLLED: 'USER_ENROLLED',
    USER_UNENROLLED: 'USER_UNENROLLED',
    ENROLLMENT_UPDATED: 'ENROLLMENT_UPDATED',
    ASYNC_UPDATE_ENROLLMENT: 'ASYNC_UPDATE_ENROLLMENT',
    ASYNC_FETCH_USER_DATA: 'ASYNC_FETCH_USER_DATA',
    USER_DATA_FETCHED: 'USER_DATA_FETCHED',
    ASYNC_FETCH_USER_ENROLLMENTS: 'ASYNC_FETCH_USER_ENROLLMENTS',
    USER_ENROLLMENTS_FETCHED: 'USER_ENROLLMENTS_FETCHED',
    ASYNC_FETCH_ADMINS: 'ASYNC_FETCH_ADMINS',
    ADMINS_FETCHED: 'ADMINS_FETCHED',
    ASYNC_CREATE_ADMIN: 'ASYNC_CREATE_ADMIN',
    ADMIN_CREATED: 'ADMIN_CREATE',
    ASYNC_DELETE_ADMIN: 'ASYNC_DELETE_ADMIN',
    ADMIN_DELETED: 'ADMIN_DELETED',
    ASYNC_FETCH_ALL_USERS: 'ASYNC_FETCH_ALL_USERS',
    ALL_USERS_FETCHED: 'ALL_USERS_FETCHED',
    ASYNC_FILTER_GLOBAL: 'ASYNC_FILTER_GLOBAL',
    GLOBAL_FETCHED: 'GLOBAL_FETCHED',
    TRAINERS_FETCH_LOADING: 'TRAINERS_FETCH_LOADING',
    CLASSES_FETCH_LOADING: 'CLASSES_FETCH_LOADING',
    COURSES_FETCH_LOADING: 'COURSES_FETCH_LOADING',
    ADMINS_FETCH_LOADING: 'ADMINS_FETCH_LOADING',
    EDIT_NEW_USER: 'EDIT_NEW_USER',
    CLEAR_NEW_USER: 'CLEAR_NEW_USER',
    ASYNC_EDIT_NEW_USER: 'ASYNC_EDIT_NEW_USER',
    TOGGLE_SHOW_FORM: 'TOGGLE_SHOW_FORM',
    TOGGLE_SHOW_FORM_SEARCH_REALMS: 'TOGGLE_SHOW_FORM_SEARCH_REALMS',
    TOGGLE_SHOW_SWITCH_ADD_REALMS: 'TOGGLE_SHOW_SWITCH_ADD_REALMS',
    ASYNC_CHECK_INFO_ABOUT_REALMS_USER: 'ASYNC_CHECK_INFO_ABOUT_REALMS_USER',
    CHECK_INFO_ABOUT_REALMS_USER: 'CHECK_INFO_ABOUT_REALMS_USER',
    CLEAR_CHECK_INFO_ABOUT_REALMS_USER: 'CLEAR_CHECK_INFO_ABOUT_REALMS_USER',
    ASYNC_CREATE_USER: 'ASYNC_CREATE_USER',
    TOGGLE_WAIT_FOR_REQUEST: 'TOGGLE_WAIT_FOR_REQUEST',
    UPLOAD_ATTACHMENT: 'UPLOAD_ATTACHMENT',
    UPDATE_ALERTS: 'UPDATE_ALERTS',
    GETTING_ATTACHMENTS: 'GETTING_ATTACHMENTS',
    DOWNLOADING_ATTACH: 'DOWNLOADING_ATTACH',
    DELETING_ATTACH: 'DELETING_ATTACH',
    SET_NEW_USER: 'SET_NEW_USER',
    IS_THIS_EDITING: 'IS_THIS_EDITING',
    INIT_EDIT_USER: 'INIT_EDIT_USER',
    FINISH_EDIT_USER: 'FINISH_EDIT_USER',
    ASYNC_CREATE_ALERT: 'ASYNC_CREATE_ALERT',
    ASYNC_FETCH_QUESTIONS: 'ASYNC_FETCH_QUESTIONS',
    CHANGE_FETCH_QUESTIONS: 'CHANGE_FETCH_QUESTIONS',
    CHANGE_SHOW_MODAL_CONFIRM_DUPLICATE: 'CHANGE_SHOW_MODAL_CONFIRM_DUPLICATE',
    CHANGE_SHOW_MODAL_ADD_QUESTION: 'CHANGE_SHOW_MODAL_ADD_QUESTION',
    CHANGE_SHOW_MODAL_DISABLE_QUESTION: 'CHANGE_SHOW_MODAL_DISABLE_QUESTION',
    CHANGE_SHOW_MODAL_REMOVE_QUESTION: 'CHANGE_SHOW_MODAL_REMOVE_QUESTION',
    ASYNC_DUPLICATE_QUESTION: 'ASYNC_DUPLICATE_QUESTION',
    ASYNC_CREATE_QUESTION: 'ASYNC_CREATE_QUESTION',
    ASYNC_UPDATE_QUESTION: 'ASYNC_UPDATE_QUESTION',
    ASYNC_FETCH_QUESTION_TO_MANAGE: 'ASYNC_FETCH_QUESTION_TO_MANAGE',
    CHANGE_QUESTION_TO_MANAGE: 'CHANGE_QUESTION_TO_MANAGE',
    ASYNC_HANDLE_ENABLE_QUESTION: 'ASYNC_HANDLE_ENABLE_QUESTION',
    ASYNC_REMOVE_QUESTION: 'ASYNC_REMOVE_QUESTION',
    CHANGE_SUCCESS_ADD_QUESTION: 'CHANGE_SUCCESS_ADD_QUESTION',
    INCREMENT_LOADING_ONLINE_TESTS: 'INCREMENT_LOADING_ONLINE_TESTS',
    DECREMENT_LOADING_ONLINE_TESTS: 'DECREMENT_LOADING_ONLINE_TESTS',
    ASYNC_FETCH_TEMPLATE_TESTS: 'ASYNC_FETCH_TEMPLATE_TESTS',
    CHANGE_TEMPLATE_TESTS: 'CHANGE_TEMPLATE_TESTS',
    ASYNC_DUPLICATE_TEMPLATE_TEST: 'ASYNC_DUPLICATE_TEMPLATE_TEST',
    CHANGE_MODAL_DUPLICATE_TEMPLATE_TEST:
        'CHANGE_MODAL_DUPLICATE_TEMPLATE_TEST',
    ASYNC_REMOVE_TEMPLATE_TEST: 'ASYNC_REMOVE_TEMPLATE_TEST',
    CHANGE_MODAL_REMOVE_TEMPLATE_TEST: 'CHANGE_MODAL_REMOVE_TEMPLATE_TEST',
    ASYNC_ADD_TEMPLATE_TEST: 'ASYNC_ADD_TEMPLATE_TEST',
    CHANGE_SUCCESS_ADD_TEMPLATE_TEST: 'CHANGE_SUCCESS_ADD_TEMPLATE_TEST',
    ASYNC_FETCH_TEMPLATE_TEST_TO_MANAGE: 'ASYNC_FETCH_TEMPLATE_TEST_TO_MANAGE',
    ASYNC_UPDATE_TEMPLATE_TEST: 'ASYNC_UPDATE_TEMPLATE_TEST',
    CHANGE_TEMPLATE_TEST_TO_MANAGE: 'CHANGE_TEMPLATE_TEST_TO_MANAGE',
    ASYNC_FETCH_PERFORMED_TESTS: 'ASYNC_FETCH_PERFORMED_TESTS',
    CHANGE_PERFORMED_TESTS: 'CHANGE_PERFORMED_TESTS',
    ASYNC_FETCH_COURSE_TEMPLATE_TESTS: 'ASYNC_FETCH_COURSE_TEMPLATE_TESTS',
    CHANGE_COURSE_TEMPLATE_TESTS: 'CHANGE_COURSE_TEMPLATE_TESTS',
    ASYNC_FETCH_CLASS_TEMPLATE_TESTS: 'ASYNC_FETCH_CLASS_TEMPLATE_TESTS',
    CHANGE_CLASS_TEMPLATE_TESTS: 'CHANGE_CLASS_TEMPLATE_TESTS',
    CHANGE_SHOULD_BE_REFRESH_QUESTIONS_DATABASE:
        'CHANGE_SHOULD_BE_REFRESH_QUESTIONS_DATABASE',
    CHANGE_SHOULD_BE_REFRESH_TEMPLATE_TESTS:
        'CHANGE_SHOULD_BE_REFRESH_TEMPLATE_TESTS',
    CHANGE_TEMPLATE_TESTS_TO_DUPLICATE: 'CHANGE_TEMPLATE_TESTS_TO_DUPLICATE',
    CHANGE_QUESTIONS_TEMPLATE_TESTS_TO_DUPLICATE:
        'CHANGE_QUESTIONS_TEMPLATE_TESTS_TO_DUPLICATE',
    ASYNC_FETCH_TEMPLATE_TESTS_TO_DUPLICATE:
        'ASYNC_FETCH_TEMPLATE_TESTS_TO_DUPLICATE',
    ASYNC_FETCH_QUESTION_TO_DUPLICATE: 'ASYNC_FETCH_QUESTION_TO_DUPLICATE',
    CHANGE_QUESTION_TO_DUPLICATE: 'CHANGE_QUESTION_TO_DUPLICATE',
    CHANGE_REDIRECT_TO_TABLE_USERS: 'CHANGE_REDIRECT_TO_TABLE_USERS',
    ASYNC_FETCH_TEST_TYPES_TO_FILTER: 'ASYNC_FETCH_TEST_TYPES_TO_FILTER',
    CHANGE_TEST_TYPES_TO_FILTER: 'CHANGE_TEST_TYPES_TO_FILTER',
    CHANGE_CENTERS_TO_FILTER: 'CHANGE_CENTERS_TO_FILTER',
    ASYNC_EXPORT_PERFORMED_TESTS: 'ASYNC_EXPORT_PERFORMED_TESTS',
    CHANGE_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS:
        'CHANGE_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS',
    RESET_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS:
        'RESET_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS',
    ASYNC_APPROVES_TEST: 'ASYNC_APPROVES_TEST',
    ASYNC_CORRECTION_TEST: 'ASYNC_CORRECTION_TEST',
    SET_SELECT_TESTS_CREATE_COURSE: 'SET_SELECT_TESTS_CREATE_COURSE',
    ASYNC_SET_SELECT_TESTS_CREATE_COURSE: 'ASYNC_SET_SELECT_TESTS_CREATE_COURSE',
    ASYNC_DISCARD_TEST: 'ASYNC_DISCARD_TEST',
};



// WEBPACK FOOTER //
// ./src/utils/constants.js